import throttle from "./throttle";
import getOffset from "./getOffset";

var WyPt2;
{
    var instances = [];
    var currentScrollPos = window.scrollY;
    var previousScrollPos = 0;
    var currentScrollDirection = "down";
    var previousScrollDirection = "down";

    WyPt2 = class {
        constructor(_options) {
            const defaults = {
                element: null,
                offset: {
                    top: "top-top",
                    bottom: "bottom-bottom",
                },
                callback: {
                    enter: function (_el, _dir) {},
                    leave: function (_el, _dir) {},
                },
                pointMode: false,
                debug: false,
            };
            const options = Object.assign({}, defaults, _options);

            this.element = options.element;
            this.offset = options.offset;
            this.callback = options.callback;
            this.pointMode = options.pointMode;
            this.debug = options.debug;

            this.args = {};

            this.wasIntersecting = false;

            this.triggerPointTop;
            this.triggerPointBottom;
            this.triggerPointEvent;

            this.animationScheduled = false;

            instances.push(this);

            this.init();

            return this;
        }

        init() {
            var rootMargin, rootMarginTop, rootMarginBottom;
            var elementOffset = getOffset(this.element);
            var elementHeight = this.element.clientHeight;
            var windowHeight = window.innerHeight;
            var viewportOffsetTop, viewportOffsetBottom;

            switch (this.offset.top) {
                case "top-bottom": // Top of element crosses bottom of viewport
                    rootMarginTop = "0%";
                    viewportOffsetTop = -windowHeight;
                    break;
                case "top-middle": // Top of element crosses middle of viewport
                    rootMarginTop = "-50%";
                    viewportOffsetTop = -windowHeight / 2;
                    break;
                case "top-top": // Top of element crosses top of viewport
                    rootMarginTop = "-100%";
                    viewportOffsetTop = 0;
                    break;
                default:
                    this.offset.top = this.offset.top;
            }

            switch (this.offset.bottom) {
                case "bottom-bottom": // Bottom of element crosses bottom of viewport
                    rootMarginBottom = "0%";
                    viewportOffsetBottom = -windowHeight;
                    break;
                case "bottom-middle": // Bottom of element crosses middle of viewport
                    rootMarginBottom = "-50%";
                    viewportOffsetBottom = -windowHeight / 2;
                    break;
                case "bottom-top": // Bottom of element crosses top of viewport
                    rootMarginBottom = "-100%";
                    viewportOffsetBottom = 0;
                    break;
                default:
                    this.offset.bottom = this.offset.bottom;
            }

            rootMargin = `${rootMarginTop} 0% ${rootMarginBottom} 0%`;

            this.triggerPointTop = elementOffset + viewportOffsetTop;
            this.triggerPointBottom = !this.pointMode
                ? elementOffset + elementHeight + viewportOffsetBottom
                : this.triggerPointTop;

            this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
                rootMargin: rootMargin,
                threshold: 0,
            });

            this.observer.observe(this.element);

            if (this.debug) {
                console.log(this);
                this.drawTriggerPoints();
            }
        }

        onIntersect(_entries, _observer) {
            _entries.forEach(this.entryHandler.bind(this));
        }

        entryHandler(_entry) {
            if (_entry.isIntersecting && !this.wasIntersecting) {
                switch (getDirection(_entry)) {
                    case "down":
                        this.triggerPointEvent = "entered-from-top";
                        break;
                    case "up":
                        this.triggerPointEvent = "entered-from-bottom";
                        break;
                }
                window.requestAnimationFrame(this.triggerPointHandler.bind(this));
                this.wasIntersecting = true;
            }
            if (!_entry.isIntersecting && this.wasIntersecting) {
                switch (getDirection(_entry)) {
                    case "down":
                        this.triggerPointEvent = "left-from-top";
                        break;
                    case "up":
                        this.triggerPointEvent = "left-from-bottom";
                        break;
                }
                window.requestAnimationFrame(this.triggerPointHandler.bind(this));
                this.wasIntersecting = false;
            }

            function getDirection(_entry) {
                var y = _entry.boundingClientRect.y;
                var height = _entry.boundingClientRect.height;
                var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

                return y + height / 2 < viewportHeight / 2 ? "down" : "up";
            }
        }

        triggerPointHandler() {
            if (this.debug) console.log(this.triggerPointEvent);
            switch (this.triggerPointEvent) {
                case "entered-from-top":
                case "entered-from-bottom":
                    this.callback.enter(this.element, currentScrollDirection);
                    break;
                case "left-towards-top":
                case "left-towards-bottom":
                    this.callback.leave(this.element, currentScrollDirection);
                    break;
            }
            this.animationScheduled = false;
        }

        drawTriggerPoints() {
            var array = [this.triggerPointTop, this.triggerPointBottom];
            var el;

            document.querySelectorAll(".wypt2-debug").forEach(function (_el) {
                _el.remove();
            });

            array.forEach(function (_val) {
                el = document.createElement("div");
                el.classList += "wypt2-debug";
                el.innerText = `wypt2-trigger-point: ${_val}px`;
                el.style.cssText = `
                    position: absolute;
                    top: ${_val}px;
                    right: 0;
                    background: yellow;
                `;
                document.body.appendChild(el);
            });
        }

        refresh() {
            this.init();
        }
    };

    WyPt2.refreshAll = function () {
        instances.forEach((_instance) => _instance.refresh());
    };

    document.addEventListener("DOMContentLoaded", function () {
        new ResizeObserver(
            throttle(function () {
                WyPt2.refreshAll();
            }, 100)
        ).observe(document.body);
    });

    window.addEventListener("resize", WyPt2.refreshAll);
}

export default WyPt2;
